export const defaultLanguage = 'fa'

const languages = ['fa', 'en']

export const setLanguage = language => {
  language && languages.includes(language) ?
    localStorage.setItem('language', language)
    :
    localStorage.setItem('language', defaultLanguage)

  return localStorage.getItem('language')
}

